import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { ModalModule } from 'ngx-bootstrap/modal'

import { AppCommonModule } from '../common/common.module'
import { EstabelecimentosComponent } from './estabelecimentos.component'
import { FiltroEstabelecimentosFormComponent } from './filtro-estabelecimentos-form/filtro-estabelecimentos-form.component'
import { EstabelecimentoService } from './shared/estabelecimento.service'
import { EstabelecimentoModalComponent } from './estabelecimento-modal/estabelecimento-modal.component'
import { EstabelecimentoModalConfirmacaoComponent } from './estabelecimento-modal-confirmacao/estabelecimento-modal-confirmacao.component'
import { OperadorasHomologadasModalComponent } from './operadoras-homologadas-modal/operadoras-homologadas-modal.component'
import { AppCoreModule } from '../core/core.module'
import { AlertModule } from 'ngx-bootstrap/alert'
import { OperadorasIndisponiveisModalComponent } from './operadoras-indisponiveis-modal/operadoras-indisponiveis-modal.component'
import { ModalTokenComponent } from './modal-token/modal-token.component'
import { SolicitacaoOperadoraModalComponent } from './solicitacao-operadora/solicitacao-operadora-modal/solicitacao-operadora-modal.component'
import { SolicitacaoOperadoraService } from './solicitacao-operadora/solicitacao-operadora.service'

@NgModule({
    imports: [AppCommonModule, AppCoreModule, ModalModule, AlertModule],
    declarations: [
        EstabelecimentosComponent,
        FiltroEstabelecimentosFormComponent,
        EstabelecimentoModalComponent,
        EstabelecimentoModalConfirmacaoComponent,
        OperadorasHomologadasModalComponent,
        OperadorasIndisponiveisModalComponent,
        SolicitacaoOperadoraModalComponent,
        ModalTokenComponent,
    ],
    providers: [EstabelecimentoService, SolicitacaoOperadoraService],
    entryComponents: [
        EstabelecimentoModalComponent,
        EstabelecimentoModalConfirmacaoComponent,
        OperadorasHomologadasModalComponent,
        OperadorasIndisponiveisModalComponent,
        SolicitacaoOperadoraModalComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EstabelecimentosModule {}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/estabelecimentos.module.ts